module.exports = __webpack_public_path__ + "img/fruits.d02354ab.jpg";